import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-clipboard-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "clipable--container",
    id: `clipable_${_ctx.id}`,
    ref: "clip_element",
    "data-clipboard-text": _ctx.payload,
    "data-cy": "clipable-container"
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("span", null, _toDisplayString(_ctx.payload), 1)
    ], true)
  ], 8, _hoisted_1))
}